import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Button, Card, Image } from "react-bootstrap";
import { getAll } from "../../api/API";
import RichTextRenderer from "../Generic/RichtextRenderer";
import LoadingSpinner from "../Generic/LoadingSpinner";
import Reactshare from "../Generic/Reactshare";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  //
  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await getAll(`/public/blog/${slug}`);
        setBlog(res || null);
      } catch (err) {
        console.error("Failed to fetch blog:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <LoadingSpinner text="Loading Blog..." />
      </div>
    );
  }

  if (!blog) {
    return (
      <Container className="py-5 text-center">
        <h3 className="text-secondary">Blog not found</h3>
        <Link to="/blogs">
          <Button variant="secondary" className="mt-3 rounded-pill px-4">
            Back to Blogs
          </Button>
        </Link>
      </Container>
    );
  }

  const { title, description, publishedDate, content, media, author } = blog;

  const authorName = author?.name || "Unknown Author";
  const authorImage = author?.avatar || null;
  const isVideo = media?.endsWith(".mp4");

  return (
    <Container
      fluid="md"
      className="py-5 px-3 px-md-5"
      style={{ maxWidth: "1000px" }}
    >
      {/* Title, Author, Share*/}
      <Row className="align-items-center mb-4 text-center text-md-start">
        <Col xs={12} md={8}>
          <h1 className="fw-bold mb-3 wise-secondary-gradient">{title}</h1>

          <div className="d-flex flex-wrap justify-content-center justify-content-md-start align-items-center gap-2 text-white small">
            <span>By</span>

            {authorImage && (
              <Image
                src={authorImage}
                roundedCircle
                alt={authorName}
                width={30}
                height={30}
                style={{ objectFit: "cover" }}
              />
            )}

            <strong className="fw-normal">{authorName}</strong>

            {publishedDate && (
              <span className="ms-2">
                {new Date(publishedDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            )}
          </div>
        </Col>

        {/* SHARE SECTION: render single Share button */}
        <Col xs="auto" className="text-center text-md-end">
          <Reactshare
            url={window.location.href}
            title={title}
            text={`Check out this blog: ${title}`}
          />
        </Col>
      </Row>

      {/*MEDIA SECTION */}
      {media && (
        <Row className="justify-content-center mb-4">
          <Col xs={12}>
            {isVideo ? (
              <div className="ratio ratio-16x9 rounded overflow-hidden shadow-sm">
                <video controls className="w-100 rounded">
                  <source src={media} type="video/mp4" />
                </video>
              </div>
            ) : (
              <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                <Card.Img
                  src={media}
                  alt={title}
                  className="w-100"
                  style={{
                    objectFit: "cover",
                    height: "auto",
                    maxHeight: "450px",
                  }}
                />
              </Card>
            )}
          </Col>
        </Row>
      )}

      {/* BLOG CONTENT*/}
      {description && (
        <Row className="mb-4">
          <Col>
            <p
              className="lead mb-4 text-center text-md-start text-white"
              style={{ fontSize: "1rem" }}
            >
              {description}
            </p>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          {Array.isArray(content?.root?.children) &&
          content.root.children.length > 0 ? (
            <div className="text-secondary">
              <RichTextRenderer content={content.root.children} />
            </div>
          ) : (
            <p className="text-secondary text-center">No content available</p>
          )}
        </Col>
      </Row>

      {/* BACK BUTTON */}
      <div className="text-center mt-5">
        <Link to="/blogs">
          <Button variant="secondary" className="rounded-pill px-4 py-2">
            Back to Blogs
          </Button>
        </Link>
      </div>
    </Container>
  );
};

export default BlogDetails;
